import Suspense from '@/components/Suspense'
import { CustomRouteProps } from '@/types/router'
import React from 'react'

const TermsOfServicePage = React.lazy(() => import('./TermsOfService'))
const PrivacyPolicyPage = React.lazy(() => import('./PrivacyPolicy'))

const termsOfServiceRoutes: CustomRouteProps[] = [
  {
    path: '/terms-of-service',
    name: 'Terms of Service',
    navigation: false,
    isInSideNav: false,
    requireAuth: false,
    element: <Suspense RouteComponent={TermsOfServicePage} />,
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    navigation: false,
    isInSideNav: false,
    requireAuth: false,
    element: <Suspense RouteComponent={PrivacyPolicyPage} />,
  },
]

export default termsOfServiceRoutes
